import React from "react";
import { Helmet } from "react-helmet-async";

import garlannd from "../../assets/garland.jpeg";
import freshFlower from "../../assets/merigold.jpeg";
import pujaItem from "../../assets/pujaItem.jpeg";
import chandu from "../../assets/chandu.jpeg";
import ganeri from "../../assets/Ganeri.jpeg";
import sugandharaja from "../../assets/Sugandharaja.jpeg";
import freshFlowers from "../../assets/freshFlower.jpeg";

import UserNavbar from "../../components/UserNavbar";

import {
  Clock3,
  Flower2,
  ShoppingBag,
  Truck,
  Phone,
  Mail,
  MapPin,
  Star,
  CheckCircle,
} from "lucide-react";

export default function Home() {
  const categories = [
    {
      title: "Fresh Flowers",
      image: freshFlower,
    },
    {
      title: "Puja Items",
      image: pujaItem,
    },
    {
      title: "Temple Garland",
      image: garlannd,
    },
  ];

  const products = [
    {
      name: "Sugandharaja",
      image: sugandharaja,
    },
    {
      name: "Chandu Flowers",
      image: chandu,
    },
    {
      name: "Ganeri Flowers",
      image: ganeri,
    },
  ];

  /* =========================================================
     APP DOWNLOAD
  ========================================================= */

  const handleShopNow = () => {
    const ua = navigator.userAgent;

    if (/Android/i.test(ua)) {
      window.open(
        "https://play.google.com/store/apps/details?id=com.frendrops&hl=en_IN",
        "_blank"
      );
      return;
    }

    if (/iPhone|iPad|iPod/i.test(ua)) {
      window.open(
        "https://apps.apple.com/us/app/frendrops/id6782789369",
        "_blank"
      );
      return;
    }

    if (/Macintosh|Mac OS X/i.test(ua)) {
      window.open(
        "https://apps.apple.com/us/app/frendrops/id6782789369",
        "_blank"
      );
      return;
    }

    window.open(
      "https://play.google.com/store/apps/details?id=com.frendrops&hl=en_IN",
      "_blank"
    );
  };

  return (
    <>
      {/* =====================================================
          SEO
      ====================================================== */}

      <Helmet>
        <title>
          FrendRops | Fresh Flower & Puja Item Delivery in Bangalore
        </title>

        <meta
          name="description"
          content="Order fresh flowers, puja kits, garlands and temple essentials online. Early morning doorstep delivery across Bangalore."
        />

        <meta
          name="keywords"
          content="flower delivery Bangalore, puja flowers online, puja items delivery, morning flower delivery, garland delivery Bangalore, fresh flowers Bangalore"
        />

        <meta
          property="og:title"
          content="FrendRops | Fresh Flower & Puja Item Delivery"
        />

        <meta
          property="og:description"
          content="Fresh flowers, puja kits, garlands and daily delivery services in Bangalore."
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            name: "FrendRops",
            telephone: "+91 8050515079",
            email: "frendrops@gmail.com",
            address: {
              "@type": "PostalAddress",
              addressLocality: "Bangalore",
              addressCountry: "IN",
            },
          })}
        </script>
      </Helmet>

      {/* =====================================================
          NAVBAR
      ====================================================== */}

      <UserNavbar />

      {/* =====================================================
          FIXED BACKGROUND IMAGE
      ====================================================== */}

      <div
        className="
          fixed
          inset-0
          z-0
          bg-cover
          bg-center
          bg-no-repeat
        "
        style={{
          backgroundImage: `url(${freshFlowers})`,
        }}
      />

      {/* =====================================================
          DOWNLOAD APP - FIXED
      ====================================================== */}

      <section
        className="
          fixed
          top-[72px]
          left-0
          right-0
          z-40

          bg-[#fffdfb]/95
          backdrop-blur-md

          border-b
          border-violet-200
          shadow-sm
        "
      >
        <div
          className="
            max-w-7xl
            mx-auto

            px-4
            sm:px-6

            py-3
            md:py-4

            flex
            items-center
            justify-between

            gap-3
            md:gap-8
          "
        >
          <div className="flex items-center gap-3 md:gap-5 min-w-0">
            {/* PHONE ICON */}

            <div
              className="
                flex-shrink-0

                w-8
                h-11

                sm:w-10
                sm:h-13

                md:w-11
                md:h-14

                border-[3px]
                border-violet-700

                rounded-lg

                relative

                flex
                justify-center
              "
            >
              <div
                className="
                  absolute
                  bottom-1.5

                  w-3
                  h-[3px]

                  bg-violet-700
                  rounded-full
                "
              />
            </div>

            {/* TEXT */}

            <p
              className="
                text-[#2d1457]

                text-sm
                sm:text-lg
                md:text-xl
                lg:text-2xl

                leading-snug

                min-w-0
              "
            >
              <span className="hidden sm:inline">
                To place an order,{" "}
              </span>

              <span className="font-bold">
                download the FrendRops app.
              </span>
            </p>
          </div>

          {/* BUTTON */}

          <button
            onClick={handleShopNow}
            className="
              flex-shrink-0

              bg-violet-700
              hover:bg-violet-800
              active:bg-violet-900

              text-white

              px-4
              sm:px-6
              md:px-8

              py-3
              md:py-3.5

              rounded-xl

              text-sm
              sm:text-base
              md:text-lg

              font-semibold

              shadow-md
              hover:shadow-lg

              transition-all
              duration-300
            "
          >
            <span className="hidden sm:inline">
              Download App
            </span>

            <span className="sm:hidden">
              Download
            </span>
          </button>
        </div>
      </section>

      {/* =====================================================
          MAIN PAGE
      ====================================================== */}

      <main
        className="
          relative
          z-10

          pt-[140px]
          md:pt-[160px]

          min-h-screen
        "
      >
        {/* =====================================================
            HERO
        ====================================================== */}

        <section
          id="home"
          className="
            relative

            min-h-[calc(100vh-145px)]
            md:min-h-[calc(100vh-165px)]

            flex
            items-center

            overflow-hidden

            bg-[#e2e0ff]/90
          "
        >
          <div
            className="
              relative
              z-10

              max-w-7xl
              mx-auto
              w-full

              px-5
              sm:px-6

              py-12
              md:py-16
            "
          >
            <div className="max-w-3xl">
              {/* BADGE */}

              <span
                className="
                  inline-flex
                  items-center

                  bg-white/75
                  backdrop-blur-sm

                  text-violet-700

                  px-3
                  py-2
                  md:px-4

                  rounded-full

                  font-semibold

                  text-xs
                  sm:text-sm
                  md:text-base

                  mb-5

                  shadow-sm
                "
              >
                🌸 Bangalore's Trusted Flower Delivery Service
              </span>

              {/* HEADING */}

              <h1
                className="
                  text-[38px]
                  sm:text-5xl
                  md:text-6xl
                  lg:text-7xl

                  font-bold

                  leading-[1.08]
                  tracking-tight

                  text-[#2d1457]
                "
              >
                Fresh Flower &
                <br />

                Puja Item Delivery
                <br />

                In Bangalore
              </h1>

              {/* DESCRIPTION */}

              <p
                className="
                  mt-6
                  md:mt-8

                  text-[17px]
                  sm:text-lg
                  md:text-xl
                  lg:text-2xl

                  text-gray-700

                  leading-7
                  md:leading-relaxed

                  max-w-2xl
                "
              >
                Get fresh flowers, garlands, puja kits, temple offerings and
                daily essentials delivered to your doorstep before sunrise.
              </p>

              {/* CTA */}

              <div
                className="
                  grid
                  grid-cols-2
                  gap-3

                  sm:flex
                  sm:flex-wrap
                  sm:gap-4

                  mt-8
                  md:mt-10
                "
              >
                <button
                  onClick={handleShopNow}
                  className="
                    bg-violet-600
                    hover:bg-violet-700
                    active:bg-violet-800

                    text-white

                    px-4
                    sm:px-8

                    py-4

                    rounded-xl

                    text-base
                    sm:text-lg

                    font-bold

                    shadow-lg
                    hover:shadow-xl

                    transition-all
                    duration-300
                  "
                >
                  Install Now
                </button>

                <button
                  onClick={() =>
                    window.open("tel:+918050515079", "_blank")
                  }
                  className="
                    bg-white/90
                    hover:bg-white

                    backdrop-blur-sm

                    border-2
                    border-violet-600

                    text-violet-700

                    px-4
                    sm:px-8

                    py-4

                    rounded-xl

                    text-base
                    sm:text-lg

                    font-bold

                    shadow-lg
                    hover:shadow-xl

                    transition-all
                    duration-300
                  "
                >
                  Call Now
                </button>
              </div>

              {/* STATS */}

              <div
                className="
                  grid
                  grid-cols-3
                  gap-3

                  md:flex
                  md:flex-wrap
                  md:gap-10

                  mt-10
                  md:mt-12
                "
              >
                <div>
                  <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-violet-700">
                    500+
                  </h3>

                  <p className="text-[11px] sm:text-sm md:text-base text-gray-700 mt-1">
                    Happy Customers
                  </p>
                </div>

                <div>
                  <h3 className="text-lg sm:text-2xl md:text-3xl font-bold text-violet-700 leading-tight">
                    Early Morning
                  </h3>

                  <p className="text-[11px] sm:text-sm md:text-base text-gray-700 mt-1">
                    Morning Delivery
                  </p>
                </div>

                <div>
                  <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-violet-700">
                    100%
                  </h3>

                  <p className="text-[11px] sm:text-sm md:text-base text-gray-700 mt-1">
                    Fresh Flowers
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* =====================================================
            FEATURES
        ====================================================== */}

        <section
          className="
            relative
            z-20

            bg-[#e2e0ff]/90

            max-w-full
            mx-auto

            px-6
            py-16
          "
        >
          <div className="max-w-7xl mx-auto grid md:grid-cols-4 gap-6">
            <div className="bg-pink-50/90 backdrop-blur-md rounded-[30px] p-8 shadow-lg">
              <div className="w-20 h-20 rounded-full bg-pink-100 flex items-center justify-center">
                <Clock3 size={38} className="text-pink-600" />
              </div>

              <h3 className="text-2xl font-bold text-[#24123f] mt-6">
                Early Morning Delivery
              </h3>

              <p className="text-gray-600 mt-4">
                Daily fresh flower delivery before sunrise.
              </p>
            </div>

            <div className="bg-violet-50/90 backdrop-blur-md rounded-[30px] p-8 shadow-lg">
              <div className="w-20 h-20 rounded-full bg-violet-100 flex items-center justify-center">
                <Flower2 size={38} className="text-violet-600" />
              </div>

              <h3 className="text-2xl font-bold text-[#24123f] mt-6">
                Fresh Flowers
              </h3>

              <p className="text-gray-600 mt-4">
                Sourced directly from flower farms every morning.
              </p>
            </div>

            <div className="bg-orange-50/90 backdrop-blur-md rounded-[30px] p-8 shadow-lg">
              <div className="w-20 h-20 rounded-full bg-orange-100 flex items-center justify-center">
                <ShoppingBag size={38} className="text-orange-500" />
              </div>

              <h3 className="text-2xl font-bold text-[#24123f] mt-6">
                Puja Essentials
              </h3>

              <p className="text-gray-600 mt-4">
                Complete puja kits, diyas, agarbatti and offerings.
              </p>
            </div>

            <div className="bg-green-50/90 backdrop-blur-md rounded-[30px] p-8 shadow-lg">
              <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center">
                <Truck size={38} className="text-green-600" />
              </div>

              <h3 className="text-2xl font-bold text-[#24123f] mt-6">
                Fast Delivery
              </h3>

              <p className="text-gray-600 mt-4">
                Reliable doorstep delivery across Bangalore.
              </p>
            </div>
          </div>
        </section>

        {/* =====================================================
            CATEGORIES
        ====================================================== */}

        <section
          id="categories"
          className="
            bg-[#e2e0ff]/90

            px-6
            py-24

            relative
            z-10
          "
        >
          <div className="max-w-7xl mx-auto">
            <h2 className="text-4xl md:text-5xl font-bold text-center text-[#2d1457]">
              Fresh Flowers & Puja Categories
            </h2>

            <div className="w-28 h-1 bg-pink-500 mx-auto mt-5 rounded-full" />

            <p className="text-center text-gray-700 text-lg md:text-xl mt-6 max-w-3xl mx-auto">
              Explore our wide range of fresh flowers, temple garlands,
              puja kits and daily worship essentials.
            </p>

            <div className="grid md:grid-cols-3 gap-8 mt-16">
              {categories.map((item, index) => (
                <div
                  key={index}
                  className="
                    relative

                    rounded-[35px]
                    overflow-hidden

                    shadow-2xl

                    group

                    bg-white/90
                  "
                >
                  <img
                    src={item.image}
                    alt={item.title}
                    className="
                      h-[340px]
                      w-full

                      object-cover

                      group-hover:scale-110

                      transition
                      duration-500
                    "
                  />

                  <div className="absolute inset-0 bg-black/35 flex items-end p-8">
                    <h3 className="text-white text-3xl md:text-4xl font-bold">
                      {item.title}
                    </h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* =====================================================
            PRODUCTS
        ====================================================== */}

        <section
          id="products"
          className="
            bg-[#e2e0ff]/90

            px-6
            py-24

            relative
            z-10
          "
        >
          <div className="max-w-7xl mx-auto">
            <h2 className="text-4xl md:text-5xl font-bold text-center text-[#2d1457]">
              Best Selling Flowers & Puja Essentials
            </h2>

            <p className="text-center text-gray-700 text-lg md:text-xl mt-6">
              Popular products loved by our customers.
            </p>

            <div className="grid md:grid-cols-3 gap-8 mt-14">
              {products.map((product, index) => (
                <div
                  key={index}
                  className="
                    bg-white/90
                    backdrop-blur-md

                    rounded-[35px]
                    overflow-hidden

                    shadow-xl
                    hover:shadow-2xl

                    transition
                    duration-300
                  "
                >
                  <img
                    src={product.image}
                    alt={product.name}
                    className="h-[320px] w-full object-cover"
                  />

                  <div className="p-7 text-center">
                    <h3 className="text-3xl font-bold text-[#24123f]">
                      {product.name}
                    </h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* =====================================================
            WHY CHOOSE US
        ====================================================== */}

        <section
          className="
            bg-[#e2e0ff]/90

            py-24

            relative
            z-10
          "
        >
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-4xl md:text-5xl font-bold text-center text-[#2d1457]">
              Why Choose FrendRops?
            </h2>

            <p className="text-center text-gray-700 mt-6 text-lg md:text-xl">
              Trusted by hundreds of families across Bangalore.
            </p>

            <div className="grid md:grid-cols-2 gap-10 mt-16">
              <div className="bg-white/90 backdrop-blur-md rounded-3xl p-8 shadow-lg">
                <div className="flex items-center gap-4">
                  <CheckCircle
                    className="text-green-600"
                    size={28}
                  />

                  <h3 className="text-2xl font-bold">
                    Fresh Flowers Daily
                  </h3>
                </div>

                <p className="text-gray-600 mt-4">
                  Fresh flowers sourced directly from farms every morning.
                </p>
              </div>

              <div className="bg-white/90 backdrop-blur-md rounded-3xl p-8 shadow-lg">
                <div className="flex items-center gap-4">
                  <CheckCircle
                    className="text-green-600"
                    size={28}
                  />

                  <h3 className="text-2xl font-bold">
                    Early Morning Delivery
                  </h3>
                </div>

                <p className="text-gray-600 mt-4">
                  Deliveries begin before sunrise for your daily puja needs.
                </p>
              </div>

              <div className="bg-white/90 backdrop-blur-md rounded-3xl p-8 shadow-lg">
                <div className="flex items-center gap-4">
                  <CheckCircle
                    className="text-green-600"
                    size={28}
                  />

                  <h3 className="text-2xl font-bold">
                    Affordable Pricing
                  </h3>
                </div>

                <p className="text-gray-600 mt-4">
                  Competitive pricing with subscription options available.
                </p>
              </div>

              <div className="bg-white/90 backdrop-blur-md rounded-3xl p-8 shadow-lg">
                <div className="flex items-center gap-4">
                  <CheckCircle
                    className="text-green-600"
                    size={28}
                  />

                  <h3 className="text-2xl font-bold">
                    Trusted Local Service
                  </h3>
                </div>

                <p className="text-gray-600 mt-4">
                  Reliable service built specifically for Bangalore residents.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* =====================================================
            TESTIMONIALS
        ====================================================== */}

        <section
          className="
            bg-[#e2e0ff]/90

            py-24

            relative
            z-10
          "
        >
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-4xl md:text-5xl font-bold text-center text-[#2d1457]">
              What Customers Say
            </h2>

            <div className="grid md:grid-cols-3 gap-8 mt-16">
              <div className="bg-white/95 rounded-3xl p-8 shadow-xl">
                <div className="flex gap-1 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={i}
                      size={20}
                      fill="#FFD700"
                      color="#FFD700"
                    />
                  ))}
                </div>

                <p className="text-gray-600 leading-relaxed">
                  Fresh flowers delivered every morning exactly on time.
                  Highly recommended.
                </p>

                <h4 className="font-bold mt-6 text-xl">
                  Priya Sharma
                </h4>

                <span className="text-gray-500">
                  Whitefield
                </span>
              </div>

              <div className="bg-white/95 rounded-3xl p-8 shadow-xl">
                <div className="flex gap-1 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={i}
                      size={20}
                      fill="#FFD700"
                      color="#FFD700"
                    />
                  ))}
                </div>

                <p className="text-gray-600 leading-relaxed">
                  Great quality flowers and puja kits. The delivery is
                  always reliable.
                </p>

                <h4 className="font-bold mt-6 text-xl">
                  Ramesh Kumar
                </h4>

                <span className="text-gray-500">
                  Sarjapur
                </span>
              </div>

              <div className="bg-white/95 rounded-3xl p-8 shadow-xl">
                <div className="flex gap-1 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={i}
                      size={20}
                      fill="#FFD700"
                      color="#FFD700"
                    />
                  ))}
                </div>

                <p className="text-gray-600 leading-relaxed">
                  Best flower delivery service in Bangalore. Fresh and
                  affordable.
                </p>

                <h4 className="font-bold mt-6 text-xl">
                  Anjali Gupta
                </h4>

                <span className="text-gray-500">
                  Bellandur
                </span>
              </div>
            </div>
          </div>
        </section>

        {/* =====================================================
            FAQ
        ====================================================== */}

        <section
          id="faq"
          className="
            bg-[#e2e0ff]/90

            px-6
            py-24

            relative
            z-10
          "
        >
          <div className="max-w-7xl mx-auto">
            <h2 className="text-4xl md:text-5xl font-bold text-center text-[#2d1457]">
              Frequently Asked Questions
            </h2>

            <p className="text-center text-gray-700 text-lg md:text-xl mt-6">
              Everything you need to know about FrendRops flower and puja
              item delivery.
            </p>

            <div className="mt-16 space-y-6 max-w-4xl mx-auto">
              <div className="bg-white/90 backdrop-blur-md rounded-3xl shadow-lg p-8">
                <h3 className="text-2xl font-bold text-[#24123f]">
                  Do you deliver flowers early in the morning?
                </h3>

                <p className="mt-4 text-gray-600 leading-relaxed">
                  Yes. Our deliveries start as early as 5:00 AM so you
                  receive fresh flowers before your daily puja and morning
                  rituals.
                </p>
              </div>

              <div className="bg-white/90 backdrop-blur-md rounded-3xl shadow-lg p-8">
                <h3 className="text-2xl font-bold text-[#24123f]">
                  Which areas do you serve?
                </h3>

                <p className="mt-4 text-gray-600 leading-relaxed">
                  We currently serve Sarjapur, Whitefield, Bellandur,
                  HSR Layout, Electronic City, Marathahalli, Varthur
                  and nearby Bangalore areas.
                </p>
              </div>

              <div className="bg-white/90 backdrop-blur-md rounded-3xl shadow-lg p-8">
                <h3 className="text-2xl font-bold text-[#24123f]">
                  Can I subscribe for daily flower delivery?
                </h3>

                <p className="mt-4 text-gray-600 leading-relaxed">
                  Absolutely. We offer daily and monthly subscription
                  plans for fresh flower delivery and puja essentials.
                </p>
              </div>

              <div className="bg-white/90 backdrop-blur-md rounded-3xl shadow-lg p-8">
                <h3 className="text-2xl font-bold text-[#24123f]">
                  Do you provide puja kits?
                </h3>

                <p className="mt-4 text-gray-600 leading-relaxed">
                  Yes. We provide complete puja kits, garlands,
                  agarbatti, camphor, diyas and other temple essentials.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* =====================================================
            CTA SECTION
        ====================================================== */}

        <section
          className="
            bg-[#e2e0ff]/90

            px-6
            py-24

            relative
            z-10
          "
        >
          <div className="max-w-7xl mx-auto">
            <div
              className="
                relative
                overflow-hidden

                bg-gradient-to-r
                from-pink-500/95
                to-violet-700/95

                backdrop-blur-md

                rounded-[45px]

                px-8
                md:px-14

                py-14
                md:py-16

                shadow-2xl
              "
            >
              <div className="max-w-3xl text-white relative z-10">
                <h2 className="text-4xl md:text-6xl font-bold leading-tight">
                  Start Your Day With Divine Freshness
                </h2>

                <p className="mt-6 text-xl md:text-2xl leading-relaxed">
                  Subscribe for daily flower and puja item delivery
                  directly to your doorstep.
                </p>

                <div className="flex flex-wrap gap-4 mt-8">
                  <button
                    onClick={handleShopNow}
                    className="
                      bg-violet-600
                      hover:bg-violet-700

                      text-white

                      px-8
                      py-4

                      rounded-xl

                      text-lg
                      font-bold

                      shadow-xl

                      transition-all
                      duration-300
                    "
                  >
                    Install Now
                  </button>

                  <button
                    onClick={() =>
                      window.open(
                        "tel:+918050515079",
                        "_blank"
                      )
                    }
                    className="
                      bg-white

                      text-violet-700

                      px-8
                      py-4

                      rounded-xl

                      text-lg
                      font-bold

                      shadow-xl

                      transition-all
                      duration-300
                    "
                  >
                    Call Us
                  </button>
                </div>
              </div>

              <div className="absolute right-10 bottom-0 text-[180px] opacity-20">
                🛵
              </div>
            </div>
          </div>
        </section>

        {/* =====================================================
            FOOTER
        ====================================================== */}

        <footer
          id="contact"
          className="
            bg-[#e2e0ff]/90

            text-[#24123f]

            py-16

            relative
            z-10
          "
        >
          <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-12">
            {/* COMPANY */}

            <div>
              <h3 className="text-4xl font-bold">
                🌸 FrendRops
              </h3>

              <p className="mt-5 text-gray-700 text-lg leading-relaxed">
                Fresh flowers, puja kits, garlands and temple
                essentials delivered daily across Bangalore.
              </p>

              <div className="mt-6">
                <span className="inline-block bg-violet-700 text-white px-4 py-2 rounded-full text-sm">
                  Trusted by Bangalore Families
                </span>
              </div>
            </div>

            {/* QUICK LINKS */}

            <div>
              <h4 className="text-2xl font-bold">
                Quick Links
              </h4>

              <ul className="mt-6 space-y-4 text-lg text-gray-700">
                <li>
                  <a
                    href="#home"
                    className="hover:text-violet-700"
                  >
                    Home
                  </a>
                </li>

                <li>
                  <a
                    href="#categories"
                    className="hover:text-violet-700"
                  >
                    Categories
                  </a>
                </li>

                <li>
                  <a
                    href="#products"
                    className="hover:text-violet-700"
                  >
                    Products
                  </a>
                </li>

                <li>
                  <a
                    href="#faq"
                    className="hover:text-violet-700"
                  >
                    FAQ
                  </a>
                </li>

                <li>
                  <a
                    href="/privacy-policy"
                    className="hover:text-violet-700"
                  >
                    Privacy Policy
                  </a>
                </li>

                <li>
                  <a
                    href="/terms-conditions"
                    className="hover:text-violet-700"
                  >
                    Terms & Conditions
                  </a>
                </li>
              </ul>
            </div>

            {/* CONTACT */}

            <div>
              <h4 className="text-2xl font-bold">
                Contact Us
              </h4>

              <div className="mt-6 space-y-5 text-lg text-gray-700">
                <div className="flex items-center gap-3">
                  <MapPin size={20} />

                  <span>
                    Bangalore, Karnataka, India
                  </span>
                </div>

                <div className="flex items-center gap-3">
                  <Mail size={20} />

                  <span>
                    frendrops@gmail.com
                  </span>
                </div>

                <div className="flex items-center gap-3">
                  <Phone size={20} />

                  <span>
                    +91 8050515079
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-violet-900/10 mt-12 pt-7 text-center text-gray-700 text-lg">
            © 2026 FrendRops. All rights reserved.
          </div>
        </footer>
      </main>

      {/* =====================================================
          WHATSAPP
      ====================================================== */}

      <a
        href="https://wa.me/918050515079"
        target="_blank"
        rel="noopener noreferrer"
        className="
          fixed

          bottom-4
          right-4

          md:bottom-6
          md:right-6

          z-50

          bg-green-500
          hover:bg-green-600

          text-white

          px-4
          py-3

          md:px-5
          md:py-4

          rounded-full

          text-sm
          md:text-base

          shadow-2xl

          font-semibold

          transition-all
          duration-300
        "
      >
        WhatsApp
      </a>
    </>
  );
}